export default function NavIconRight({ fill = "#000" }: { fill?: string }) {
	return (
		<svg viewBox="0 0 2688 4824" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M2688 2412L0 4823.02L0.000210778 0.986328L2688 2412Z" fill={fill} />
		</svg>
	);
}
